
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import App from './App.tsx';
import './index.css';
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "next-themes";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/query-client";
import { configureApiClient } from "./lib/api-config";
import { VoniProvider } from "@voniai/react";
import { OpenAPI } from "./lib/api-generated";

// Initialize performance monitoring (Web Vitals: LCP, FID, CLS)
import "./lib/performance-monitor";

// Initialize API configuration
configureApiClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <QueryClientProvider client={queryClient}>
        <VoniProvider config={{ apiUrl: OpenAPI.BASE }}>
          <App />
        </VoniProvider>
        <Toaster position="top-right" />
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>
);
